import React from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
}
export function Input({
  label,
  error,
  helperText,
  required,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-232">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-233">
          {label}
          {required && <span className="text-red-500 ml-1" data-id="element-234">*</span>}
        </label>}
      <input className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${error ? 'border-red-500' : 'border-gray-300'} ${className}`} {...props} data-id="element-235" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-236">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-237">{helperText}</p>}
    </div>;
}